"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var Vote_1 = require("./Vote");
var utils_1 = require("../libs/utils");
var TaggedPost = function (props) {
    var featureRequest = props.featureRequest;
    return (preact_1.h("a", { href: featureRequest.url, target: "_blank", class: "flex justify-start break-words max-w-full overflow-y-auto mb-5" },
        preact_1.h(Vote_1.default, { featureRequest: featureRequest }),
        preact_1.h("div", null,
            preact_1.h("h5", { className: "mb-1 text-sm font-medium text-gray-900" }, featureRequest.title),
            preact_1.h("p", { className: "text-xs text-gray-700" }, utils_1.trimDescription(featureRequest.preview)))));
};
exports.default = TaggedPost;
